import React from "react";
import {SiteHeader,SiteFooter} from "./site/Shell.jsx";
import {HomeScreen} from "./site/HomeScreen.jsx";
import {ServicesScreen,AgentsScreen,ContactScreen} from "./site/InnerScreens.jsx";
import {CasesScreen} from "./site/CasesScreen.jsx";
import {CaseScreen} from "./site/CaseScreen.jsx";
import {CASES} from "../content/casos.js";

/* Una ruta por caso, generada a partir de content/casos.js: casos/<slug> ->
   /casos/<slug>/. Mismo mecanismo de ROUTES que el resto del sitio, solo que
   la clave lleva el slug y trae el caso ya resuelto en `props`. */
const CASE_ROUTES=Object.fromEntries(CASES.map(c=>[
  `casos/${c.slug}`,
  {path:`/casos/${c.slug}/`,Comp:CaseScreen,props:{item:c}}
]));

export const ROUTES={
  home:{path:"/",Comp:HomeScreen},
  servicios:{path:"/servicios/",Comp:ServicesScreen},
  agentes:{path:"/agentes/",Comp:AgentsScreen},
  contacto:{path:"/contacto/",Comp:ContactScreen},
  casos:{path:"/casos/",Comp:CasesScreen},
  ...CASE_ROUTES
};
const PATH_TO_ROUTE=Object.fromEntries(Object.entries(ROUTES).map(([k,v])=>[v.path,k]));

export function Site({initialRoute}){
  const [route,setRoute]=React.useState(initialRoute);
  const go=r=>{
    setRoute(r);
    if(typeof window!=="undefined"){
      window.scrollTo(0,0);
      const path=ROUTES[r].path;
      if(window.location.pathname!==path) window.history.pushState({route:r},"",path);
    }
  };
  React.useEffect(()=>{
    const onPop=()=>setRoute(PATH_TO_ROUTE[window.location.pathname]||"home");
    window.addEventListener("popstate",onPop);
    return ()=>window.removeEventListener("popstate",onPop);
  },[]);
  const {Comp,props}=ROUTES[route];
  return <>
    <SiteHeader route={route.startsWith("casos/")?"casos":route} go={go}/>
    <Comp go={go} {...(props||{})}/>
    <SiteFooter go={go}/>
  </>;
}
